import { useParams } from 'react-router-dom';

import { AppLiveStreamPage } from '~/components/pages/AppLiveStreamPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppLiveStreamRoute: React.FC = () => {
  const { appId, liveStreamId } = useParams();

  if (!appId || !liveStreamId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppLiveStreamPage appId={appId} liveStreamId={liveStreamId} />
    </DashboardTemplate>
  );
};
